import LeonDialog from './src/main.vue'

export default LeonDialog



// WEBPACK FOOTER //
// ./src/plugin/LeonDialog/index.js